









































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component
export default class PaymentDialog extends Vue {
  paymentDialog: boolean = true;

  closeDialog() {
    this.$emit('closed');
  }

  get iframeUrl() {
    return this.$store.state.payment.response;
  }

  setupMessageListener() {
    window.addEventListener('message', this.handleMessage, false);
  }

  handleMessage(event: MessageEvent) {
  if (event.data === 'paymentCompleted') {
    const paymentBtn = document.getElementById('paymentBtn');
    if (paymentBtn) {
      paymentBtn.click();
    }
    // Veya doğrudan closeDialog metodunu çağırabilirsiniz
    // this.closeDialog();
  }
}

  beforeDestroy() {
    // Bileşen yok edilmeden önce event listener'ı kaldır
    window.removeEventListener('message', this.handleMessage);
  }
}
